// extracted by mini-css-extract-plugin
export default {"container":"LC88X_hK"};